import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, AlertController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { Retailer } from '../../models/retailer.model';

import { RetailerProvider } from '../../providers/retailer/retailer';

import { ShopsPage } from '../shops/shops';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-retailers',
  templateUrl: 'retailers.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class RetailersPage {

  countryID: number;
  countryName: string;

  err: string;
  loading: boolean;

  retailers: Retailer[];

  constructor(public storage: Storage, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public modalCtrl: ModalController, public translate: TranslateService, public retailerProvider: RetailerProvider) {
    this.countryID = this.navParams.get('countryID');
    this.countryName = navParams.get('countryName');
  }

  private getRetailers(countryID: number) {
    this.loading = true;
    this.retailerProvider.getAllByCountryID(countryID)
      .subscribe(
        retailers => this.retailers = retailers,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openShopsModal(retailer: Retailer) {
    this.storage.get('current_brand').then((brand) => {
      let shopsModal = this.modalCtrl.create(ShopsPage, {retailerID: retailer.id, retailerName: retailer.name }, { cssClass: (brand) ? brand.name : '' });
      shopsModal.present();

      shopsModal.onDidDismiss(shop => {
        this.viewCtrl.dismiss(shop);
      });
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    this.getRetailers(this.countryID);
  }

}



// WEBPACK FOOTER //
// ./src/pages/retailers/retailers.ts